"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCountries = void 0;
exports.mockCountries = [
    'Brazil',
    'Bulgaria',
    'Canada',
    'Chile',
    'Denmark',
    'Egypt',
    'France',
    'Greece',
    'Japan',
    'Mexico',
    'Poland',
    'Spain',
    'Sweden',
    'Taiwan',
    'Turkey',
    'Ukraine',
    'Yugoslavia',
];
